/**
 * Labstep
 *
 * @module components/EntityImport/Progress
 * @desc Display EntityImport status and progress
 */

import { Flex } from 'labstep-web/core/Flex';
import {
  EntityImportStatus,
  EntityImportStepMode,
  type Step,
} from 'labstep-web/models/entity-import.model';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import type React from 'react';
import type { SemanticCOLORS } from 'semantic-ui-react';
import { Progress } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { EntityImportProgressProps } from './types';

export const getProgressColor = (step: Step): SemanticCOLORS => {
  if (step.success_count === step.total_count) {
    return 'green';
  }
  return 'blue';
};

const actionWords = {
  create: 'created',
  link: 'linked',
  revert: 'reverted',
};

export const EntityImportProgress: React.FC<
  EntityImportProgressProps
> = ({ entityImport }) => (
  <Flex spacing="gap" column>
    {entityImport.step_data &&
      Object.entries(entityImport.step_data.steps)
        .filter(([_, step]) => {
          return (
            entityImport.status ===
              EntityImportStatus.revert_started ||
            entityImport.status ===
              EntityImportStatus.revert_completed ||
            step.mode !== EntityImportStepMode.revert
          );
        })
        .map(([key, step]) => {
          return (
            <Flex
              key={key}
              grow
              spacing="gap"
              vAlignContent="center"
              className={styles.rowContainer}
            >
              <div className={styles.progress}>
                <Progress
                  percent={Math.ceil(
                    (step.success_count / step.total_count) * 100,
                  )}
                  indicating={
                    entityImport.status === EntityImportStatus.started
                  }
                  success={step.success_count === step.total_count}
                  progress
                  color={getProgressColor(step)}
                />
              </div>
              <span>
                {step.success_count} / {step.total_count}{' '}
                {getHumanReadableEntityName(step.entity_name)}{' '}
                {actionWords[step.mode]}
              </span>
            </Flex>
          );
        })}
  </Flex>
);
